import { motion } from "framer-motion";

export default function StorySection({
  children,
  delay = 0,
  variant = "default",
}) {
  const variants = {
    default: {
      initial: { opacity: 0, y: 80 },
      animate: { opacity: 1, y: 0 },
    },

    soft: {
      initial: { opacity: 0, y: 60, scale: 0.97 },
      animate: { opacity: 1, y: 0, scale: 1 },
    },

    cinematic: {
      initial: { opacity: 0, y: 120, scale: 0.94 },
      animate: { opacity: 1, y: 0, scale: 1 },
    },

    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
    },
  };

  return (
    <motion.section
      initial={variants[variant].initial}
      whileInView={variants[variant].animate}
      viewport={{ once: true, margin: "-140px" }}
      transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1], // cinematic easing
        delay,
      }}
      className="relative"
    >
      {children}
    </motion.section>
  );
}
